//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from '../icon'

export default {
  props: {
    title: String,
    description: String,
    stepNumber: Number,
    stepLast: Boolean,
    icon: String,
    status: String,
    tailWidth: Object
  },
  computed: {
    iconName () {
      return this.icon || 'check'
    }
  },
  created () {
    this.currentStatus = this.status
    this.currentStepLast = this.stepLast
    this.currentStepNumber = this.stepNumber
  },
  data () {
    return {
      currentStatus: '',
      currentStepLast: false,
      currentStepNumber: 0
    }
  },
  components: {
    Icon
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/step/step-item.vue